import { DependenciesAspect } from './dependencies.aspect';

export type { DependenciesMain } from './dependencies.main.runtime';
export default DependenciesAspect;
export { DependenciesAspect };
